var render = function render(){var _vm=this,_c=_vm._self._c;return _c('view',[_c('view',{staticClass:"iframeClass"},[_c('iframe',{attrs:{"name":"iframeFB","id":"iframeId","src":_vm.iframeUrl,"frameborder":"0","width":"100%","height":"275px","scrolling":"no"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }